import { Model } from "@/models";
import ClientCompany from "./Company";

export default class ClientAgentProduct extends Model {
  static type = "clientsAgentProducts";

  name!: string;
  principalProductId?: string;
  principalCompanyId?: string;
  agentCompanyId!: string;

  agentCompany!: ClientCompany;
  principalAgentCompany?: ClientCompany;
  principalAgentProduct?: ClientAgentProduct;
}

export type ProductWithoutPrincipals = {
  name: string;
  products: ClientAgentProduct[];
};

export type MissingPrincipalProductRecord = {
  companyId: string;
  companyName: string;
  productsWithoutPrincipals: ProductWithoutPrincipals[];
};

export type MissingPrincipalProductCompany = {
  companyId: string;
  companyName: string;
};
